module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.activeAbsenceReason) ? _c('DModal', {
    attrs: {
      "show-close": false,
      "isBgOverlay": true
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "text-dark",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [(_vm.isActiveAbsenceReasonIsReadyToDelete) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.delete_absence')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.change_start_and_end_date')))])]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": _vm.close
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__body d-modal__body--edit-absence",
    class: {
      'd-modal__body--edit-absence--with-opus': _vm.isShowSalaryInfoBox
    }
  }, [_c('div', {
    staticClass: "d-modal__body--edit-absence__header"
  }, [_c('img', {
    attrs: {
      "src": _vm.showUser.default_thumb_url,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "absent-user__name"
  }, [_c('h3', [_vm._v(_vm._s(_vm.showUser.name))]), _vm._v(" "), _c('div', {
    staticClass: "reason"
  }, [_c('p', [_vm._v(_vm._s(_vm.getReasonTitle(_vm.activeAbsenceReason)))]), _vm._v(" "), _c('p', [(_vm.isOngoing && _vm.isAbsenceOngoing) ? _c('span', {
    staticClass: "badge badge--orange badge--small"
  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.ongoing_absence')))]) : _vm._e(), _vm._v(" "), (!_vm.isOngoing && _vm.getIsAbsenceMultipleDays) ? _c('span', {
    staticClass: "badge badge--small"
  }, [_vm._v(" " + _vm._s(_vm.$t('vue2.substitution_user.multiple_days')))]) : _vm._e()])]), _vm._v(" "), _c('p', [(_vm.getSerialListItem) ? _c('span', [_vm._v("\n            " + _vm._s(_vm.formatDate(_vm.getSerialListItem.from_date)) + "\n            - " + _vm._s(_vm.formatDate(_vm.getSerialListItem.to_date)) + ", " + _vm._s(_vm._f("showTime")(_vm.getSerialListItem.from_time)) + " - " + _vm._s(_vm._f("showTime")(_vm.getSerialListItem.to_time)) + "\n          ")]) : _c('span', [_vm._v("\n            " + _vm._s(_vm._f("showDate")(_vm.activeAbsenceReason.start)) + " -\n            "), _c('span', [_vm._v(_vm._s(_vm._f("showTime")(_vm.activeAbsenceReason.end)))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__body--edit-absence__flex"
  }, [_c('div', {
    staticClass: "d-modal__body--edit-absence__left"
  }, [_c('div', {
    staticClass: "d-modal__body--edit-absence__body"
  }, [(!_vm.isActiveAbsenceReasonIsReadyToDelete) ? _c('div', {
    staticClass: "d-modal__page-1"
  }, [(_vm.hasSentSdFravaer) ? _c('div', {
    staticClass: "do-warning marg-1-bottom"
  }, [_vm._v("\n                Fraværet er allerede sendt til SD. Ændrer du datoerne, sendes en rettelse ved næste\n                automatiske indberetning. Andre ændringer, fx af årsagen, rettes ikke automatisk og\n                skal ændres direkte i SD."), (_vm.hasDraftSdFravaer && !_vm.isReasonChangedAwayFromSd) ? [_vm._v("\n                Usendte indberetninger i udbakken opdateres med dine ændringer.")] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.isReasonChangedAwayFromSd) ? _c('div', {
    staticClass: "do-warning marg-1-bottom"
  }, [_vm._v("\n                Den valgte årsag har ingen SD-kode, men fraværet har usendte SD-indberetninger i\n                udbakken. De opdateres ikke ved årsagsskift og vil stadig blive sendt med den\n                oprindelige årsag. Slet dem i udbakken under Løn og Fravær →\n                Fraværsindberetninger, hvis de ikke skal sendes.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.reason) ? _c('div', {
    staticClass: "d-modal__body--edit-absence__body__input-group"
  }, [_c('label', {
    staticClass: "d-label marg-1-bottom"
  }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.reason')))]), _vm._v(" "), _c('div', {
    staticClass: "absence-reason"
  }, [_c('div', [_c('DSelect', {
    attrs: {
      "items": _vm.subsAbsenceReasonsSorted,
      "multiple": false,
      "items-selected": _vm.reason,
      "placeholder": _vm.$t('vue2.substitution.choose_absence_reason')
    },
    on: {
      "update": _vm.setReason
    },
    scopedSlots: _vm._u([(_vm.isAbsenceIntegrationActive) ? {
      key: "item-badge",
      fn: function(ref) {
        var item = ref.item;

        return [(item.kmd_absence_code_id) ? _c('span', {
          staticClass: "do-opus-badge"
        }, [_vm._v("OPUS")]) : _vm._e(), _vm._v(" "), (item.sd_absence_code_id) ? _c('span', {
          staticClass: "do-sd-badge"
        }, [_vm._v("SD")]) : _vm._e()]
      }
    } : null], null, true)
  }, [_vm._v(" "), _c('div', {
    attrs: {
      "slot": "noMatch"
    },
    slot: "noMatch"
  }, [_c('h4', [_vm._v("\n                          " + _vm._s(_vm.$t('vue2.dselect.no_matching_results')) + "\n                        ")])])])], 1)]), _vm._v(" "), (_vm.showErrors) ? _c('span', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.reason_must_be_filled')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-modal__body--edit-absence__body__input-group"
  }, [_c('label', {
    staticClass: "d-label marg-1-bottom"
  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.date_label')))]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('DatepickerRange', {
    attrs: {
      "allowSameDate": true,
      "startdate": _vm.originalStart,
      "enddate": _vm.originalEnd
    },
    on: {
      "startchanged": _vm.setStartDate,
      "endchanged": _vm.setEndDate
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "absence-no-end-date",
    class: [{
      'absence-no-end-date--active': _vm.isAbsenceOngoing
    }, {
      'absence-no-end-date--disabled': !_vm.isOngoingAbsenceAllowed
    }]
  }, [(!_vm.isOngoingAbsenceAllowed) ? _c('div', {
    staticClass: "absence-no-end-date--not-allowed"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "absence-no-end-date__inner",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.isAbsenceOngoing = !_vm.isAbsenceOngoing
      }
    }
  }, [_c('app-toggle', {
    attrs: {
      "prop-on": _vm.isAbsenceOngoing
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.ongoing_absence')))])], 1), _vm._v(" "), _c('DQuestionMark', [_c('p', {
    attrs: {
      "slot": "answer"
    },
    slot: "answer"
  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.ongoing_absence_explained')))])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__body--edit-absence__body__input-group"
  }, [_c('label', {
    staticClass: "d-label marg-1-bottom"
  }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.time')))]), _vm._v(" "), _c('TimeChanger', {
    attrs: {
      "showIcon": true,
      "start": _vm.startTime,
      "end": _vm.endTime
    },
    on: {
      "updateStart": _vm.setStartTime,
      "updateEnd": _vm.setEndTime
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.deleteAbsenceFollowingDates.length > 0) ? _c('p', [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.absence_will_be_deleted')))]), _vm._v(" "), _vm._l((_vm.deleteAbsenceFollowingDates), function(date, idx) {
    return _c('span', [(idx > 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.formatDate(date)))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.isActiveAbsenceReasonIsReadyToDelete && _vm.hasSdFravaer) ? _c('div', {
    staticClass: "do-warning marg-1-bottom"
  }, [(_vm.hasSentSdFravaer) ? [_vm._v("\n                Fraværet er allerede sendt til SD. Sendte indberetninger trækkes ikke tilbage, når\n                fraværet slettes, og skal korrigeres manuelt i SD.\n              ")] : _vm._e(), _vm._v(" "), (_vm.hasDraftSdFravaer) ? [_vm._v("\n                " + _vm._s(_vm.hasSentSdFravaer ? 'Usendte indberetninger' : 'Fraværets usendte indberetninger') + "\n                i udbakken slettes sammen med fraværet.\n              ")] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.originalDatesNotInNewRange.length > 0) ? _c('div', {
    staticClass: "d-modal__page-2"
  }, [_c('SubsDeleteAbsence', {
    attrs: {
      "calendarId": this.activeAbsenceReason.calendar_id,
      "firstRange": _vm.originalDatesNotInNewRangeMinimum,
      "lastRange": _vm.originalDatesNotInNewRangeMaximum,
      "dates": _vm.originalDatesNotInNewRange,
      "startTime": _vm.startTime,
      "endTime": _vm.endTime
    },
    on: {
      "lessonsWithSubs": _vm.setLessonsWithSubs,
      "gotLessons": function($event) {
        _vm.isLessonsLoaded = true
      },
      "changed": _vm.setDeleteSubs
    }
  })], 1) : _vm._e()])]), _vm._v(" "), (_vm.isShowSalaryInfoBox) ? _c('div', {
    staticClass: "edit-absence__opus-sidebar"
  }, [(!_vm.isLoadedSalarySystemInfo) ? _c('div', {
    staticClass: "edit-absence__opus-loading"
  }, [_c('div', {
    staticClass: "do-spinner"
  })]) : _vm._e(), _vm._v(" "), (_vm.isLoadedSalarySystemInfo && _vm.isShowSdInfoBox) ? _c('div', {
    staticClass: "edit-absence__opus-content"
  }, [_c('div', {
    staticClass: "do-sd-badge do-opus-badge--large opus-info__header"
  }, [_vm._v("SD")]), _vm._v(" "), _c('div', {
    staticClass: "opus-info__field"
  }, [_c('label', {
    staticClass: "opus-info__label"
  }, [_vm._v("Ansættelse")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedEmploymentId),
      expression: "selectedEmploymentId"
    }],
    staticClass: "do-select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedEmploymentId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.onEmploymentChange($event.target.value)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("— Vælg ansættelsesnummer —")]), _vm._v(" "), _vm._l((_vm.userEmployments), function(employment) {
    return _c('option', {
      key: employment.id,
      domProps: {
        "value": employment.id
      }
    }, [_vm._v("\n                  " + _vm._s(employment.title) + " - " + _vm._s(employment.employment_number || employment.id) + "\n                ")])
  })], 2), _vm._v(" "), (!_vm.isEmploymentSelected && _vm.showErrors) ? _c('span', {
    staticClass: "error-message"
  }, [_vm._v("\n                Ansættelsesnummer skal vælges\n              ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "opus-info__field"
  }, [_c('label', {
    staticClass: "opus-info__label"
  }, [_vm._v("Fraværsårsag")]), _vm._v(" "), _c('div', {
    staticClass: "opus-info__reason-display"
  }, [(_vm.getSDAbsence) ? _c('span', {
    staticClass: "opus-info__reason-code"
  }, [_vm._v("\n                  " + _vm._s(_vm.getSDAbsence.loenart) + _vm._s(_vm.getSDAbsence.title ? ' - ' + _vm.getSDAbsence.title : '') + "\n                ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "opus-info__field"
  }, [_c('label', {
    staticClass: "opus-info__label"
  }, [_vm._v("Dato")]), _vm._v(" "), _c('div', {
    staticClass: "opus-info__date-text"
  }, [(_vm.isAbsenceOngoing) ? _c('span', [_vm._v(_vm._s(_vm.startDateFormatted) + " - Åbenstående")]) : _c('span', [_vm._v(_vm._s(_vm.dateRangeFormatted) + " "), _c('span', {
    staticClass: "opus-info__date-days"
  }, [_vm._v("(" + _vm._s(_vm.dateRangeDaysFormatted) + ")")])])]), _vm._v(" "), (_vm.isOngoingAbsenceAllowed) ? _c('div', {
    staticClass: "opus-info__toggle-row opus-info__toggle-row--secondary"
  }, [_c('div', {
    staticClass: "do-opus-whole-day-toggle",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.setIsAbsenceOngoing(!_vm.isAbsenceOngoing)
      }
    }
  }, [_c('app-toggle', {
    attrs: {
      "prop-on": _vm.isAbsenceOngoing
    }
  }), _vm._v(" "), _c('span', [_vm._v("Indberet som åbenstående")])], 1), _vm._v(" "), _c('DQuestionMark', [_c('p', {
    staticClass: "text-dark",
    attrs: {
      "slot": "answer"
    },
    slot: "answer"
  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.ongoing_absence_explained')))])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "opus-info__field"
  }, [_c('label', {
    staticClass: "opus-info__label"
  }, [_vm._v("Tid")]), _vm._v(" "), (_vm.useTime) ? _c('div', {
    staticClass: "opus-info__date-text"
  }, [_vm._v("\n                " + _vm._s(_vm.startTime.format('HH:mm')) + " - " + _vm._s(_vm.endTime.format('HH:mm')) + " "), _c('span', {
    staticClass: "opus-info__date-days"
  }, [_vm._v("(" + _vm._s(_vm.timeRangeHoursFormatted) + ")")])]) : _c('div', {
    staticClass: "opus-info__date-text"
  }, [_vm._v("\n                Hel dag\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "opus-info__toggle-row opus-info__toggle-row--secondary"
  }, [_c('div', {
    staticClass: "do-opus-whole-day-toggle",
    on: {
      "click": function($event) {
        _vm.useTime = !_vm.useTime
      }
    }
  }, [_c('app-toggle', {
    attrs: {
      "prop-on": !_vm.useTime
    }
  }), _vm._v(" "), _c('span', [_vm._v("Indberet som hel dag")])], 1), _vm._v(" "), _c('DQuestionMark', [_c('p', {
    staticClass: "text-dark",
    attrs: {
      "slot": "answer"
    },
    slot: "answer"
  }, [_vm._v("Toggle fra for at indberette timebaseret fravær, hvis fraværet kun gælder en del af dagen.")])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isLoadedSalarySystemInfo && _vm.isShowOpusInfoBox) ? _c('div', {
    staticClass: "edit-absence__opus-content"
  }, [_c('div', {
    staticClass: "do-opus-badge do-opus-badge--large opus-info__header"
  }, [_vm._v("Opus")]), _vm._v(" "), _c('div', {
    staticClass: "opus-info__field"
  }, [_c('label', {
    staticClass: "opus-info__label"
  }, [_vm._v("Ansættelse")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedEmploymentId),
      expression: "selectedEmploymentId"
    }],
    staticClass: "do-select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedEmploymentId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.onEmploymentChange($event.target.value)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("— Vælg ansættelsesnummer —")]), _vm._v(" "), _vm._l((_vm.userEmployments), function(employment) {
    return _c('option', {
      key: employment.id,
      domProps: {
        "value": employment.id
      }
    }, [_vm._v("\n                  " + _vm._s(employment.title) + " - " + _vm._s(employment.employment_number || employment.id) + "\n                ")])
  })], 2), _vm._v(" "), (!_vm.isEmploymentSelected && _vm.showErrors) ? _c('span', {
    staticClass: "error-message"
  }, [_vm._v("\n                Ansættelsesnummer skal vælges\n              ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "opus-info__field"
  }, [_c('label', {
    staticClass: "opus-info__label"
  }, [_vm._v("Fraværsårsag")]), _vm._v(" "), _c('div', {
    staticClass: "opus-info__reason-display"
  }, [(_vm.getOPUSAbsence) ? _c('span', {
    staticClass: "opus-info__reason-code"
  }, [_vm._v("\n                  " + _vm._s(_vm.getOPUSAbsence.absence_type) + _vm._s(_vm.getOPUSAbsence.absence_type_text ? ' - ' + _vm.getOPUSAbsence.absence_type_text : '') + "\n                ")]) : _vm._e()]), _vm._v(" "), (_vm.isShowExtraInformation) ? _c('div', {
    staticClass: "opus-info__extra-info"
  }, [(_vm.getOPUSAbsence && _vm.getOPUSAbsence.additional_data === 'Maternity') ? [_c('label', {
    staticClass: "opus-info__label opus-info__label--secondary"
  }, [_vm._v("Ekstra information til barselssager")]), _vm._v(" "), (_vm.isLoadingAdditionalData) ? _c('div', {
    staticClass: "do-spinner do-spinner--small"
  }) : (_vm.additionalDataError) ? _c('div', {
    staticClass: "opus-info__error"
  }, [_c('span', {
    staticClass: "opus-info__error-icon"
  }, [_vm._v("⚠")]), _vm._v(" "), _c('span', [_vm._v("Kunne ikke hente data fra Opus")])]) : (_vm.additionalDataOptions.length > 0) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAdditionalData),
      expression: "selectedAdditionalData"
    }],
    staticClass: "do-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedAdditionalData = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("— Vælg ekstra information —")]), _vm._v(" "), _vm._l((_vm.additionalDataOptions), function(option) {
    return _c('option', {
      key: option.MaternityCaseKey,
      domProps: {
        "value": option.MaternityCaseKey
      }
    }, [_vm._v("\n                      " + _vm._s(option.ExpectedDeliveryDate) + " - " + _vm._s(option.MaternityCaseKey) + "\n                    ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.hasLoadedAdditionalData && _vm.additionalDataOptions.length === 0) ? _c('p', {
    staticClass: "opus-info__note"
  }, [_vm._v("\n                    Der er ingen barselssager tilknyttet denne medarbejder i Opus.\n                  ")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.getOPUSAbsence && _vm.getOPUSAbsence.additional_data === 'Reason') ? [_c('label', {
    staticClass: "opus-info__label opus-info__label--secondary"
  }, [_vm._v("Ekstra information til tjenestefri")]), _vm._v(" "), (_vm.isLoadingAdditionalData) ? _c('div', {
    staticClass: "do-spinner do-spinner--small"
  }) : (_vm.additionalDataError) ? _c('div', {
    staticClass: "opus-info__error"
  }, [_c('span', {
    staticClass: "opus-info__error-icon"
  }, [_vm._v("⚠")]), _vm._v(" "), _c('span', [_vm._v("Kunne ikke hente data fra Opus")])]) : (_vm.additionalDataOptions.length > 0) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAdditionalData),
      expression: "selectedAdditionalData"
    }],
    staticClass: "do-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedAdditionalData = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("— Vælg ekstra information —")]), _vm._v(" "), _vm._l((_vm.additionalDataOptions), function(option) {
    return _c('option', {
      key: option.ReasonCode,
      domProps: {
        "value": option.ReasonCode
      }
    }, [_vm._v("\n                      " + _vm._s(option.ReasonCodeText) + " - " + _vm._s(option.ReasonCode) + "\n                    ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.hasLoadedAdditionalData && _vm.additionalDataOptions.length === 0) ? _c('p', {
    staticClass: "opus-info__note"
  }, [_vm._v("\n                    Der er ingen tjenestefri årsager tilknyttet denne medarbejder i Opus.\n                  ")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.getOPUSAbsence && _vm.getOPUSAbsence.additional_data === 'WorkInjury') ? [_c('label', {
    staticClass: "opus-info__label opus-info__label--secondary"
  }, [_vm._v("Ekstra information til arbejdsskader")]), _vm._v(" "), (_vm.isLoadingAdditionalData) ? _c('div', {
    staticClass: "do-spinner do-spinner--small"
  }) : (_vm.additionalDataError) ? _c('div', {
    staticClass: "opus-info__error"
  }, [_c('span', {
    staticClass: "opus-info__error-icon"
  }, [_vm._v("⚠")]), _vm._v(" "), _c('span', [_vm._v("Kunne ikke hente data fra Opus")])]) : (_vm.additionalDataOptions.length > 0) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAdditionalData),
      expression: "selectedAdditionalData"
    }],
    staticClass: "do-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedAdditionalData = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("— Vælg ekstra information —")]), _vm._v(" "), _vm._l((_vm.additionalDataOptions), function(option) {
    return _c('option', {
      key: option.AccidentNumber,
      domProps: {
        "value": option.AccidentNumber
      }
    }, [_vm._v("\n                      " + _vm._s(option.AccidentDate) + " - " + _vm._s(option.AccidentNumber) + "\n                    ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.hasLoadedAdditionalData && _vm.additionalDataOptions.length === 0) ? _c('p', {
    staticClass: "opus-info__note"
  }, [_vm._v("\n                    Der er ingen arbejdsskadesager tilknyttet denne medarbejder i Opus.\n                  ")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.getOPUSAbsence && _vm.getOPUSAbsence.additional_data === 'Child') ? [_c('label', {
    staticClass: "opus-info__label opus-info__label--secondary"
  }, [_vm._v("Ekstra information til omsorgsdage")]), _vm._v(" "), (_vm.isLoadingAdditionalData) ? _c('div', {
    staticClass: "do-spinner do-spinner--small"
  }) : (_vm.additionalDataError) ? _c('div', {
    staticClass: "opus-info__error"
  }, [_c('span', {
    staticClass: "opus-info__error-icon"
  }, [_vm._v("⚠")]), _vm._v(" "), _c('span', [_vm._v("Kunne ikke hente data fra Opus")])]) : (_vm.additionalDataOptions.length > 0) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAdditionalData),
      expression: "selectedAdditionalData"
    }],
    staticClass: "do-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedAdditionalData = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("— Vælg ekstra information —")]), _vm._v(" "), _vm._l((_vm.additionalDataOptions), function(option) {
    return _c('option', {
      key: option.ChildNumber,
      domProps: {
        "value": option.ChildNumber
      }
    }, [_vm._v("\n                      " + _vm._s(option.FirstName) + " " + _vm._s(option.LastName) + " - " + _vm._s(option.ChildNumber) + "\n                    ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.hasLoadedAdditionalData && _vm.additionalDataOptions.length === 0) ? _c('p', {
    staticClass: "opus-info__note"
  }, [_vm._v("\n                    Der er ingen barn tilknyttet denne medarbejder i Opus.\n                  ")]) : _vm._e()] : _vm._e(), _vm._v(" "), (!_vm.isAdditionalDataSelected && _vm.showErrors) ? _c('span', {
    staticClass: "error-message"
  }, [_vm._v("\n                  " + _vm._s(_vm.additionalDataValidationError) + "\n                ")]) : _vm._e()], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "opus-info__field"
  }, [_c('label', {
    staticClass: "opus-info__label"
  }, [_vm._v("Dato")]), _vm._v(" "), _c('div', {
    staticClass: "opus-info__date-text"
  }, [(_vm.isAbsenceOngoing) ? _c('span', [_vm._v(_vm._s(_vm.startDateFormatted) + " →")]) : _c('span', [_vm._v(_vm._s(_vm.dateRangeFormatted) + " "), _c('span', {
    staticClass: "opus-info__date-days"
  }, [_vm._v("(" + _vm._s(_vm.dateRangeDaysFormatted) + ")")])])]), _vm._v(" "), (_vm.isOpusAllowOpen) ? _c('div', {
    staticClass: "opus-info__toggle-row opus-info__toggle-row--secondary"
  }, [_c('div', {
    staticClass: "do-opus-whole-day-toggle",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.setIsAbsenceOngoing(!_vm.isAbsenceOngoing)
      }
    }
  }, [_c('app-toggle', {
    attrs: {
      "prop-on": _vm.isAbsenceOngoing
    }
  }), _vm._v(" "), _c('span', [_vm._v("Indberet som åbenstående")])], 1), _vm._v(" "), _c('DQuestionMark', [_c('p', {
    staticClass: "text-dark",
    attrs: {
      "slot": "answer"
    },
    slot: "answer"
  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.ongoing_absence_explained')))])])], 1) : (!_vm.isOpusAllowOpen) ? _c('p', {
    staticClass: "opus-info__note--muted"
  }, [_vm._v("\n                Åbenstående fravær er ikke muligt for denne fraværsårsag\n              ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "opus-info__field"
  }, [_c('label', {
    staticClass: "opus-info__label"
  }, [_vm._v("Tid")]), _vm._v(" "), (_vm.useTime) ? _c('div', {
    staticClass: "opus-info__date-text"
  }, [_vm._v("\n                " + _vm._s(_vm.startTime.format('HH:mm')) + " - " + _vm._s(_vm.endTime.format('HH:mm')) + " "), _c('span', {
    staticClass: "opus-info__date-days"
  }, [_vm._v("(" + _vm._s(_vm.timeRangeHoursFormatted) + ")")])]) : _c('div', {
    staticClass: "opus-info__date-text"
  }, [_vm._v("\n                Hel dag\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "opus-info__toggle-row opus-info__toggle-row--secondary"
  }, [_c('div', {
    staticClass: "do-opus-whole-day-toggle",
    on: {
      "click": function($event) {
        _vm.useTime = !_vm.useTime
      }
    }
  }, [_c('app-toggle', {
    attrs: {
      "prop-on": !_vm.useTime
    }
  }), _vm._v(" "), _c('span', [_vm._v("Indberet som hel dag")])], 1), _vm._v(" "), _c('DQuestionMark', [_c('p', {
    staticClass: "text-dark",
    attrs: {
      "slot": "answer"
    },
    slot: "answer"
  }, [_vm._v("Toggle fra for at indberette timebaseret fravær, hvis fraværet kun gælder en del af dagen.")])])], 1)])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons d-modal__body--edit-absence__actions"
  }, [_c('div', [(!_vm.isActiveAbsenceReasonIsReadyToDelete) ? _c('button', {
    staticClass: "bttn bttn-danger marg-5-right",
    on: {
      "click": function($event) {
        return _vm.$store.commit('setIsActiveAbsenceReasonIsReadyToDelete', true)
      }
    }
  }, [_c('span', {
    staticClass: "icon-bin"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__body--edit-absence__actions__right"
  }, [_c('button', {
    staticClass: "marg-5-right",
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (_vm.isActiveAbsenceReasonIsReadyToDelete) ? [_c('button', {
    staticClass: "submit-button submit-button--danger",
    on: {
      "click": _vm.removeSubsAndDeleteAbsence
    }
  }, [(_vm.eventsToRemovedSubs.length > 0) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.remove_subs_and_delete_absence')))]) : _vm._e(), _vm._v(" "), (_vm.lessonsWithSubs.length > 0 && _vm.eventsToRemovedSubs.length < 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.keep_subs_and_delete_absence')))]) : _vm._e(), _vm._v(" "), (_vm.lessonsWithSubs.length < 1 && _vm.eventsToRemovedSubs.length < 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.delete_absence')))]) : _vm._e()])] : [(_vm.originalDatesNotInNewRange.length > 0) ? _c('button', {
    staticClass: "submit-button",
    on: {
      "click": _vm.removeSubsAndUpdateAbsence
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.common.update')) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.originalDatesNotInNewRange.length < 1 && this.eventsToRemovedSubs.length < 1) ? _c('button', {
    staticClass: "submit-button",
    on: {
      "click": _vm.updateDates
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.common.update')) + "\n            ")]) : _vm._e()]], 2)])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5f3c020a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subs/SubsEditAbsence.vue
// module id = 1951
// module chunks = 1